export default "__VITE_ASSET__sW8Usb1V__"